import Vue from 'vue'

Vue.mixin({
	methods: {
		formatDate(dateString) {
			const date = new Date(dateString)

			if(date) {
				return [
					date.getFullYear(),
					(date.getMonth() + 1),
					date.getDay()
				].join('/') + ' '+ [
					date.getHours(),
					date.getMinutes(),
					date.getSeconds()
				].join(':')
			}

			return ''
		},
		mapArrayById(arr, id) {
			let obj = {}

			arr.forEach(item => {
				obj[item[id]] = item
			})

			return obj
		},
		sortArrayByKey(arr, key) {
			return arr.sort((a, b) => {
				return b[key] < a[key] ?  1 : b[key] > a[key] ? -1 : 0
			})
		}
	}
})


// WEBPACK FOOTER //
// ./src/mixins.js